export const checkIsPhotoFormat = format => {
  const acceptedFormats = ["png", "jpg", "jpeg"];
  return acceptedFormats.some(
    acceptedFormat => acceptedFormat.toLowerCase() === format
  );
};
